<template>
  <div style="display: flex">
    <div class="star-container">
      <font-awesome-icon size="2x" class="star" :icon="['fas', 'star']" />
      <div class="backround-container">
        <div class="background-div left" :style="{ background: rating >= 0.5 ? getPrimaryColor() : '#CBD5E1' }"></div>
        <div class="background-div right" :style="{ background: rating >= 1 ? getPrimaryColor() : '#CBD5E1' }"></div>
      </div>
    </div>
    <div class="star-container">
      <font-awesome-icon size="2x" class="star" :icon="['fas', 'star']" />
      <div class="backround-container">
        <div class="background-div left" :style="{ background: rating >= 1.5 ? getPrimaryColor() : '#CBD5E1' }"></div>
        <div class="background-div right" :style="{ background: rating >= 2 ? getPrimaryColor() : '#CBD5E1' }"></div>
      </div>
    </div>
    <div class="star-container">
      <font-awesome-icon size="2x" class="star" :icon="['fas', 'star']" />
      <div class="backround-container">
        <div class="background-div left" :style="{ background: rating >= 2.5 ? getPrimaryColor() : '#CBD5E1' }"></div>
        <div class="background-div right" :style="{ background: rating >= 3 ? getPrimaryColor() : '#CBD5E1' }"></div>
      </div>
    </div>
    <div class="star-container">
      <font-awesome-icon size="2x" class="star" :icon="['fas', 'star']" />
      <div class="backround-container">
        <div class="background-div left" :style="{ background: rating >= 3.5 ? getPrimaryColor() : '#CBD5E1' }"></div>
        <div class="background-div right" :style="{ background: rating >= 4 ? getPrimaryColor() : '#CBD5E1' }"></div>
      </div>
    </div>
    <div class="star-container">
      <font-awesome-icon size="2x" class="star" :icon="['fas', 'star']" />
      <div class="backround-container">
        <div class="background-div left" :style="{ background: rating >= 4.5 ? getPrimaryColor() : '#CBD5E1' }"></div>
        <div class="background-div right" :style="{ background: rating >= 5 ? getPrimaryColor() : '#CBD5E1' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "reviewStars",
  props: { rating: Number },
  created() {
    // console.log("reviewStar.vue is created ->", this.rating)
  },
}
</script>

<style lang="scss" scoped>
.star-container {
  padding-right: 4px;
  .backround-container {
    display: flex;
    .background-div {
      width: 15px;
      height: 30px;
    }
    .left {
      border-radius: 2px 0px 0px 2px;
    }
    .right {
      border-radius: 0px 2px 2px 0px;
    }
  }
  .star {
    transform: scale(0.7);
    width: 30px;
    height: 30px;
    color: white;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/reviewStar.vue